
import { Vue, Component, Prop } from "vue-property-decorator";
import GET_CONTRACTOR_VISITS from "@/apollo/projects/GetContractorClientsVisits.gql";
import {
  User,
  Company,
  Project,
  Query_RootProjectArgs,
} from "@/generated/graphql";
import { cloneDeep } from "lodash-es";
import { isEqual } from "lodash-es";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
import ContractorClientsVisitsFiltersQuery from "@/entities/filters/ContractorClientsVisitsFilters";
import CardPagination from "@/components/card/PaginationNew.vue";
import ClientsVisitsCard from "@/components/companyProjects/ClientsVisitsCardAccepted.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import contractorClientsVisitsFiltersTemplate from "@/data/filtersTemplates/contractorClientsVisitsFiltersTemplate";
import RouteNames from "@/entities/RouteNames";
import ClientsVisitsCollectionFilters from "@/components/companyProjects/ClientsVisitsCollectionFilters.vue";
import ProjectsFiltersQuery from "@/entities/filters/ClientsFiltersQuery";
import GET_CONTRACTOR_ACTIVITIES from "@/apollo/projectActivities/GetContractorActivities.gql";
import ResourceAcceptedVisits from "@/components/projects/activities/ResourceAcceptedVisits.vue";
import moment from "moment";

@Component({
  components: {
    LoadingOverlay,
    CardPagination,
    ResourceAcceptedVisits,
    EmptyListPlaceholder,
    ClientsVisitsCollectionFilters,
    EmptyListImageProjects,
  },
  apollo: {
    // clients: {
    //   query: GET_CONTRACTOR_VISITS,
    //   variables() {
    //     return this.visitsQueryFilter;
    //   },
    //   update(data) {
    //     const today = new Date();
    //     const filteredClients = data.clients.filter(
    //       (client) =>
    //         client.project_activities && client.project_activities.length > 0
    //     );

    //     const flattenData = filteredClients.flatMap((client) => {
    //       return client.project_activities.map((activity) => ({
    //         ...activity, // All activity fields
    //         clientData: {
    //           id: client.id,
    //           client_id: client.client_id,
    //           client_name: client.client_name,
    //           dob: client.dob,
    //           gender: client.gender,
    //           location: client.location,
    //           manager: client.manager,
    //           project_tags: client.project_tags,
    //         },
    //       }));
    //     });

    //     // 🔽 Filter out past occurrences and sort by proximity to today's date
    //     const filteredAndSortedData = flattenData
    //       .filter((activity) => {
    //         const activityDate = activity.start_date
    //           ? new Date(activity.start_date)
    //           : null;
    //         const isValid = activityDate && activityDate >= today;
    //         return isValid;
    //       })
    //       .sort((a, b) => {
    //         const dateA = a.start_date ? new Date(a.start_date).getTime() : 0;
    //         const dateB = b.start_date ? new Date(b.start_date).getTime() : 0;
    //         return dateA - dateB;
    //       });

    //     // Update counts to reflect only filtered and sorted data
    //     this.paginationConfig.total = filteredAndSortedData.length;
    //     this.paginationConfig.loadedCount = filteredAndSortedData.length;
    //     this.totalCount = filteredAndSortedData.length;
    //     return filteredAndSortedData;
    //   },
    //   skip() {
    //     return !this.currentUser?.id;
    //   },
    // },
    activities: {
      query: GET_CONTRACTOR_ACTIVITIES,
      variables() {
        return this.activitiesArgs;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.project_activity.length;
        this.totalCount = data.total.aggregate.count;
        return data.project_activity;
      },
    },
  },
})
export default class AcceptedVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  activities: any[] | null = null;
  paginationConfig: PaginationConfig = { ...paginationConfig };
  routeNames = RouteNames;
  totalCount: number = 0;

  get currentUserId(): string {
    return this.currentUser?.id;
  }

  get currentUserRole(): string {
    return this.currentUser?.role;
  }

  get project(): any {
    // Since we're getting activities directly, we need to extract project info from the first activity
    // or provide a default project context
    return this.activities && this.activities.length > 0 
      ? this.activities[0].project 
      : null;
  }

  getClientData(activity: any): any {
    // Extract client data from the activity's project
    if (!activity?.project) return null;
    
    const project = activity.project;
    return {
      id: project.id,
      client_id: project.client_id,
      client_name: project.client_name,
      dob: project.dob,
      gender: project.gender,
      location: project.location,
      manager: project.manager,
      project_tags: project.project_tags,
    };
  }

  get activitiesArgs(): Object {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    return {
      offset: nextOffset,
      limit,
      where: {
        accepted: { _eq: true },
        drafted: { _eq: false },
        deleted: { _eq: false },
        completed: { _eq: false },
        start_date: {
          _gte: moment().format("YYYY-MM-DD"),
        },
        contractor: {
          user: {
            id: {
              _eq: this.currentUser.id,
            },
          },
        },
      },
    };
  }

  get loading(): boolean {
    return this.$apollo.queries.activities.loading;
  }

  get empty(): boolean {
    if (!this.activities) {
      return false;
    }
    return this.activities?.length === 0;
  }
  projectFilters: ContractorClientsVisitsFiltersQuery = cloneDeep(
    contractorClientsVisitsFiltersTemplate
  );
  updateFilters(filters: ProjectsFiltersQuery): void {
    const dataEqual = isEqual(filters, this.projectFilters);

    if (dataEqual) {
      return;
    }
    this.projectFilters = { ...filters, title: "" };
  }

  resetFilters(): void {
    if (isEqual(this.projectFilters, contractorClientsVisitsFiltersTemplate)) {
      return;
    }

    this.projectFilters = cloneDeep(contractorClientsVisitsFiltersTemplate);
    this.paginationConfig = { ...paginationConfig };
  }

  get emptyListMessage(): string {
    // const entitiesName = "clients";
    // const filtersEmpty = isEqual(
    //   this.projectFilters,
    //   contractorClientsVisitsFiltersTemplate
    // );

    // if (filtersEmpty) {
    //   return getEmptyListMessage(entitiesName);
    // }

    // return getEmptyFiltersResultMessage(entitiesName);
    return "You currently do not have any Visits";
  }

  get visitsQueryFilter() {
    const { page, limit } = this.paginationConfig;
    const nextOffset = page * limit - limit;
    const { client_name, managers, location, contractorUpdatedAt } =
      this.projectFilters;
    const filterConditions = [];
    const filterAcitvityConditions = [];
    if (managers.length) {
      filterConditions.push({
        manager: {
          id: { _in: managers },
        },
      });
    }
    if (client_name) {
      filterConditions.push({
        client_name: { _ilike: `%${client_name}%` },
      });
    }
    if (location) {
      filterAcitvityConditions.push({ location: { _ilike: `%${location}%` } });
    }

    if (contractorUpdatedAt) {
      const startDate = moment(contractorUpdatedAt)
        .utc()
        .startOf("day")
        .toISOString();
      const endDate = moment(contractorUpdatedAt)
        .utc()
        .endOf("day")
        .toISOString();

      const datesConditions = [
        {
          _and: [
            { start_date: { _gte: startDate } },
            { start_date: { _lte: endDate } },
          ],
        },
      ];

      filterAcitvityConditions.push({
        _and: datesConditions,
      });
    }

    return {
      offset: nextOffset,
      limit: limit,
      where: {
        _and: [{ drafted: { _eq: false } }, ...filterConditions],
      },
      projectActivitiesWhere: {
        _and: [
          { accepted: { _eq: true } },
          {
            drafted: {
              _eq: false,
            },
          },
          { completed: { _eq: false } },
          {
            deleted: {
              _eq: false,
            },
          },
          {
            contractor: {
              user: {
                id: {
                  _eq: this.currentUser.id,
                },
              },
            },
          },
          ...filterAcitvityConditions,
        ],
      },
    };
  }
}
